import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Apps, CalenderHeading } from "../../../constants";
import DragCalendar from "./dragCalendar";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

// This component renders a calendar interface with drag-and-drop functionality.
const CalendarContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={CalenderHeading} parent={Apps} />
      <Container fluid className="calendar-basic">
        <Card>
          <CardBody>
            <Row>
              <Col sm="12">
                <Row>
                  <DragCalendar />
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default CalendarContainer;
